import React from 'react';
import AgentManagement from '../../components/packing_list/AgentManagement';

const AgentManagementPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <AgentManagement />
        </div>
    );
};

export default AgentManagementPage;
